export const enum NAME {
  APPARATUS = 'APPARATUS',
  APPARATUS_MONITOR = 'APPARATUS_MONITOR',
  APPARATUS_IPVMS = 'IPVMS',
  COST_BILL_DETAIL = 'COST_BILL_DETAIL',
  DEDUCTION = 'DEDUCTION',
  WORKFLOW = 'WORKFLOW',
  VIEW_STATUS = 'VIEW_STATUS',
}
